/**
 * Central export for player components
 *
 * Note: Player.tsx (HTML-based) has been removed.
 * Players now render via SVG using PlayersOverlay (canvas/PlayersOverlay.tsx)
 * and AnimatedPlayersOverlay (animation/AnimatedPlayersOverlay.tsx).
 */

export { PlayerLabelDialog } from './PlayerLabelDialog'
